import { Fragment } from "react";
import React from "react";
import { Link } from "react-router-dom";
import "../static/css/navbar.css";

import useMediaQuery from "../Hooks/useMediaQuery";
// import MmenuLight from "../static/js/vendors/mmenu-light";

import logo_krezco from "../static/images/logo-krezco.svg";
import useToggle from "../Hooks/useToggle";
import krezco from "../static/images/krezco-logo.PNG";
import empuje from "../static/images/Empuje_Logo-blanco.png";
//cambio de logo de empuje a children header krez-88
import Children from "../static/images/Nuevo-Logo-ChildrenBelieve-blanco.webp";

function HeaderHome() {
  const matchedMobile = useMediaQuery("(max-width: 927px)");
  const [isPanelOpen, togglePanel] = useToggle(false);

  return (
    <Fragment>
      {/* <div id="mobile-menu">
        <div id="mmenu">
          <ul>
            <li className="header__menuItem">
              <a href="">Para Candidatos/as</a>
            </li>
            <li className="header__menuItem">
              <a href="">Para Empresas</a>
            </li>
            <li className="header__menuItem">
              <a href="">Para Formación</a>
            </li>
            <li className="header__menuItem">
              <a href="">Sobre Nosotros</a>
            </li>
            <li className="header__menuItem">
              <a href="">
                <i className="fas fa-user"></i>Acceso
              </a>
            </li>
            <li className="header__menuItem">
              <a href="">¡Te Ayudamos!</a>
            </li>
          </ul>
        </div>
      </div> */}
      <header className="header">
        {matchedMobile && (
          <Homemenu fabAction={togglePanel} isOpen={isPanelOpen} />
        )}
        <div className="header__container container">
          <div className="row align-items-center" id="containerAcceso">
            <div
              className="col-4 col-md-4 col-lg-3 col-sm-6 header__logo"
              id="containerlogos"
            >
              <img src={logo_krezco} alt="Logo Krezco"></img>
            </div>
            <div className="col-0 col-md-3 col-lg-6 header__menu">
              <ul>
                <li className="header__menuItem lse">
                  <Link to="/">Inicio</Link>
                </li>
                <li className="header__menuItem lse">
                  <Link to="/Empresas">Empresas</Link>
                </li>
                <li className="header__menuItem lse">
                  <Link to="/Formacion">Formación</Link>
                </li>
                <li className="header__menuItem lse ">
                  <Link to="/Sobrenosotros">Sobre Nosotros</Link>
                </li>
                <li className="header__menuItembtn lse">
                  <Link to="/Login" className="btn btn--gradient" id="acceso">
                    <i className="fas fa-user"></i> Acceso
                  </Link>
                </li>
                <li className="header__menuItem lse">
                  <Link to="/Teayudamos">¡Te Ayudamos!</Link>
                </li>
              </ul>
            </div>
            <div
              className="col-4 col-md-4 col-lg-2 col-sm-6 header__logo"
              id="containerlogos"
            >
              <img
                src={Children}
                alt="Logo Krezco"
                id="logoabajo"
                className="header__logo"
              ></img>
            </div>
          </div>
        </div>

        <div id="submenu" className={isPanelOpen ? "open" : ""}>
          <div className="row align-items-center">
            <div className="submenu__logo">
              <img src={krezco} alt="Logo Krezco"></img>
            </div>
            <ul>
              <li className="submenus">
                <Link to="/" className="buttonitem buttonitem1" id="acceso1">
                  Candidatos/as
                </Link>
              </li>
              <li className="submenus">
                <Link
                  to="/Empresas"
                  className="buttonitem buttonitem1"
                  id="acceso1"
                >
                  Empresas
                </Link>
              </li>
              <li className="submenus">
                <Link
                  to="/Formacion"
                  className="buttonitem buttonitem1"
                  id="acceso1"
                >
                  Formación
                </Link>
              </li>
              <li className="submenus">
                <Link
                  to="/Sobrenosotros"
                  className="buttonitem buttonitem1"
                  id="acceso1"
                >
                  Nosotros
                </Link>
              </li>
              <li className="submenus">
                <Link
                  to="/Teayudamos"
                  className="buttonitem buttonitem1"
                  id="acceso1"
                >
                  ¡Te Ayudamos!
                </Link>
              </li>
              <li className="submenus">
                <Link
                  to="/Login"
                  className="buttonitem buttonitem1"
                  id="acceso1"
                >
                  <i className="fas fa-user"></i> Acceso
                </Link>
              </li>
              <li className="menu_cerrar">
                {matchedMobile && (
                  <Fabcerrar fabAction={togglePanel} isOpen={isPanelOpen} />
                )}
              </li>
            </ul>
          </div>
        </div>
      </header>
    </Fragment>
  );

  function Homemenu({ fabAction, isOpen }) {
    return (
      <div
        onClick={fabAction}
        className={"checkbtn-home" + (isOpen ? "move" : "")}
      >
        <input type="checkbox" id="check" />
        <label for="check" className="checkbtn-home">
          <i className="fas fa-bars"></i>
        </label>
      </div>
    );
  }
  function Fabcerrar({ fabAction, isOpen }) {
    return (
      <div
        onClick={fabAction}
        className={"menu_cerrar" + (isOpen ? "move" : "")}
      >
        <li className="menu_cerrar">
          <Link className="btn btn--gradient">Cerrar</Link>
        </li>
      </div>
    );
  }
}

export default HeaderHome;
